export default __webpack_public_path__ + "static/images/c9904739bff113260677a5266f74b71e.png";